import React, { useContext, useEffect, useState } from 'react';
import logoSm from '../../../images/logo/pineapple-logo.svg';
import iconDashboard from '../../../images/icon-dashboard.svg';
import HeadsetIcon from '../../../images/headset.svg';

import iconApartment from '../../../images/icon-apartment.svg';
import iconVisits from '../../../images/icon-visits.svg';
import iconSettings from '../../../images/icon-setting.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import iconVisitor from '../../../images/icon-visitor.svg';
import iconAnalytics from '../../../images/icon-analytics.svg';
import iconPropertyReport from '../../../images/icon-property-report.svg';
import { AvailabilityRedirectionContext } from '../../../components/context/availabilityRedirection';
import { clearSyncGuestCardMessage } from '../../../redux/sync-guestCard/actions/syncGuestCard.action';
import { useDispatch } from 'react-redux';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';

import AmenitiesLogo from '../../../images/amenities.svg';
import UserManagement from '../../../images/user_management.svg';
import RolesAndPermission from '../../../images/roles_permission.svg';
import StaffManagement from '../../../images/staff_add.svg';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../components/auth/login/Login';
import styles from './Sidebar.module.css';
import { resetPermission } from '../../../redux/setInitialPermission/actions/setInitialPermission.action';
import MaintenanceIcon from '../../../components/svgIcons/MaintennaceIcon';
import Tooltip from '../../../components/common/tooltip/Tooltip';
import PineappleWithText from '../../../images/pineapple_with_text.png';
import LogoutIcon from '../../../components/svgIcons/LogoutIcon';
import KeyLockerIcon from '../../../components/svgIcons/KeyLockerIcon';
import ConciergeIcon from '../../../components/svgIcons/ConciergeIcon';
import { userInfo } from 'os';


const sidebar = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch<AppDispatch>();
	const [path, setPath] = useState('');
	const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
	// State for sidebar expand/collapse - default collapsed on mobile widths so it doesn't
	// overlap page content on first load; expanded by default on larger screens.
	const [isExpanded, setIsExpanded] = useState(() => {
		if (typeof window === 'undefined') return true;
		return window.innerWidth > 768;
	});

	const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
	const permission = useSelector((state: IRootState) => state?.permissionsReducer?.data);
	const canReadDashboard = hasPermission("Dashboard", "Dashboard", "read");
	const canReadProperty = hasPermission("Properties & Units", "Property", "read");
	const canReadAvailability = hasPermission("Self-Guided Tours", "Availability", "read");
	const canReadAppointment = hasPermission("Self-Guided Tours", "Appointments", "read");
	const canReadVisitor = hasPermission("Visitors", "Visitor", "read");
	const canReadMetrics = hasPermission("Metrics", "Metric", "read");
	const canReadReports = hasPermission("Property Report", "Report", "read");
	const canViewAmenities = hasPermission("Amenity", "Amenities", "read");
	const canDelete = hasPermission("User Management", "Users Management", "delete");
	const canSetRolesAndPermissions = hasPermission("Roles and Permissions", "Roles", "read");
	const canReadVendor = hasPermission('Self-Guided Tours', 'Vendor', 'read');
	const canReadKeyPickUpDrop = hasPermission('Self-Guided Tours', "Key pickup & drop event", 'read')
	const canManageStaff = hasPermission("Staff Management", "Staff", "read");
	const canSupportTicket = hasPermission("Support Tickets", "Support Ticket", "read");
	const canReadPropertyDashboard = hasPermission("Property Dashboard", "Dashboard", "read");
	const [email, setEmail] = useState<string>('');

	useEffect(() => {
		const email = localStorage.getItem('email');
		const user = JSON.parse(localStorage.getItem('user') || '');
		const userData = JSON.parse(JSON.stringify(user));

		setEmail(email || '');
	}, []);

	useEffect(() => {
		setPath(location.pathname);
	}, [location]);

	// Update CSS variable when sidebar state changes
	useEffect(() => {
		const sidebarWidth = isExpanded ? '240px' : '80px';
		document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
	}, [isExpanded]);

	const handleLogout = () => {
		localStorage.clear();
		sessionStorage.clear();
		dispatch(resetPermission());
		navigate('/', { replace: true });
	};

	const redirectTo = () => {
		if (canReadDashboard) {
			navigate('/');
		} else if (canReadProperty) {
			navigate('/locations');
		} else if ((canReadAppointment || canReadAvailability)) {
			navigate('/visits');
		} else if (canReadVisitor) {
			navigate('/visitor');
		} else if (canReadMetrics) {
			navigate('/metrics');
		} else if (canReadReports) {
			navigate('/property-report')
		} else if (canViewAmenities) {
			navigate('/amenities')
		} else if (canDelete) {
			navigate('/user-management')
		} else if (canSetRolesAndPermissions) {
			navigate('/role-listing')
		} else if (canManageStaff) {
			navigate('/staff-management')
		} else if (canSupportTicket) {
			navigate('/support-ticket')
		} else {
			navigate('/no-permission');
		}
	}

	useEffect(() => {
		if (!(path.includes('/location') || path.includes('/edit-location') || path.includes('/add-location'))) {
			sessionStorage.clear();
		}
	}, [path]);

	return (
		<div className={`${styles.sidebar} ${isExpanded ? styles.expanded : styles.collapsed}`}>
			<div className={styles.sidebarContainer}>
				<ul>
					<li onClick={() => redirectTo()} className={`${styles.logo} ${isExpanded ? styles.expandedLogo : ''}`}>
						<img src={isExpanded ? PineappleWithText : logoSm} alt="logo" width={isExpanded ? 100 : 36} height={isExpanded ? 100 : 50} />
						{/* {isExpanded && <span className={styles.logoText}>Pineapple</span>} */}
					</li>
				</ul>
				<div className={styles.sidebarMenu}>
					<ul>

						{permission && <React.Fragment >
							{canReadPropertyDashboard && (!isExpanded ?
								<Tooltip text="Dashboard"><li>
									<div onClick={() => navigate('/dashboard')}
										className={path === '/dashboard' ? styles.active : ''}>
										<img src={iconDashboard} alt="dashboard Icon" />
									</div>
								</li></Tooltip>
								:
								<li>
									<div onClick={() => navigate('/dashboard')}
										className={path === '/dashboard' ? styles.active : ''}>
										<img src={iconDashboard} alt="dashboard Icon" />
										<span className={styles.menuText}>Dashboard</span>
									</div>
								</li>
							)}
							{/* {!!canReadDashboard && (
								!isExpanded ?
									<Tooltip text="Dashboard"><li>
										<div onClick={() => navigate('/dashboard')}
											className={path === '/dashboard' ? styles.active : ''}>
											<img src={iconApartment} alt="Location Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/dashboard')}
											className={path === '/dashboard' ? styles.active : ''}>
											<img src={iconApartment} alt="Location Icon" />
											<span className={styles.menuText}>Dashboard</span>
										</div>
									</li>
							)} */}
							{!!canReadProperty && (
								!isExpanded ?
									<Tooltip text="Property"><li>
										<div onClick={() => navigate('/locations')}
											className={path === '/' || path === '/locations' || path.includes('/location/') || path.includes('/unitDetails/') || path.includes('/add-location') || path.includes('/edit-location') || path.includes('/location-map') ? styles.active : ''}>
											<img src={iconApartment} alt="Location Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/locations')}
											className={path === '/' || path === '/locations' || path.includes('/location/') || path.includes('/unitDetails/') || path.includes('/add-location') || path.includes('/edit-location') || path.includes('/location-map') ? styles.active : ''}>
											<img src={iconApartment} alt="Location Icon" />
											<span className={styles.menuText}>Property</span>
										</div>
									</li>
							)}
							{!!(canReadAppointment || canReadAvailability) && (
								!isExpanded ?
									<Tooltip text="Self-Guided Tours"><li>
										<div className={
											path === '/visits' ||
												path === '/add-availability/locations' ||
												path === '/add-availability/units' ||
												path === '/add-availability/booking' ||
												path === '/add-availability/confirm'
												? styles.active
												: ''
										}
											onClick={() => {
												availabilityRedirectionContext?.setAvailabilityData({
													locationId: '',
													unitId: '',
													selectedDate: '',
													slotRange: '',
													locationName: '',
													unitName: '',
													lockerNumber: 0,
												});
												navigate('/visits');
											}}
										>
											<img src={iconVisits} alt="Visits Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div className={
											path === '/visits' ||
												path === '/add-availability/locations' ||
												path === '/add-availability/units' ||
												path === '/add-availability/booking' ||
												path === '/add-availability/confirm'
												? styles.active
												: ''
										}
											onClick={() => {
												availabilityRedirectionContext?.setAvailabilityData({
													locationId: '',
													unitId: '',
													selectedDate: '',
													slotRange: '',
													locationName: '',
													unitName: '',
													lockerNumber: 0,
												});
												navigate('/visits');
											}}
										>
											<img src={iconVisits} alt="Visits Icon" />
											<span className={styles.menuText}>Self-Guided Tours</span>
										</div>
									</li>
							)}
							{(!!canReadVisitor) && (
								!isExpanded ?
									<Tooltip text="Visitor"><li>
										<div onClick={() => {
											dispatch(clearSyncGuestCardMessage());
											navigate('/visitor');
										}}
											className={path === '/visitor' || path === '/create-appointment' || path === '/create-visitor' ? styles.active : ''}>
											<img src={iconVisitor} alt="visitor Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => {
											dispatch(clearSyncGuestCardMessage());
											navigate('/visitor');
										}}
											className={path === '/visitor' || path === '/create-appointment' || path === '/create-visitor' ? styles.active : ''}>
											<img src={iconVisitor} alt="visitor Icon" />
											<span className={styles.menuText}>Visitor</span>
										</div>
									</li>
							)}

							{(!!canReadMetrics) && (
								!isExpanded ?
									<Tooltip text="Metrics"><li>
										<div onClick={() => {
											navigate('/metrics');
										}}
											className={path === '/metrics' ? styles.active : styles.inactive}
										>
											<img src={iconAnalytics} alt="Metrics Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => {
											navigate('/metrics');
										}}
											className={path === '/metrics' ? styles.active : styles.inactive}
										>
											<img src={iconAnalytics} alt="Metrics Icon" />
											<span className={styles.menuText}>Metrics</span>
										</div>
									</li>
							)}

							{(canReadReports) && (
								!isExpanded ?
									<Tooltip text="Property Report"><li >
										<div onClick={() => navigate('/property-report')} className={path === '/property-report' ? styles.active : ''}>
											<img src={iconPropertyReport} alt="Property Report Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/property-report')} className={path === '/property-report' ? styles.active : ''}>
											<img src={iconPropertyReport} alt="Property Report Icon" />
											<span className={styles.menuText}>Property Report</span>
										</div>
									</li>
							)}

							{(canViewAmenities) && (
								!isExpanded ?
									<Tooltip text="Amenities"><li >
										<div onClick={() => navigate('/amenities')} className={path.includes('/amenities') ? styles.active : styles.inactive}>
											<img src={AmenitiesLogo} alt="amenities Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/amenities')} className={path.includes('/amenities') ? styles.active : styles.inactive}>
											<img src={AmenitiesLogo} alt="amenities Icon" />
											<span className={styles.menuText}>Amenities</span>
										</div>
									</li>
							)}

							{canDelete && (
								!isExpanded ?
									<Tooltip text="User Management"><li >
										<div onClick={() => navigate('/user-management')} className={path.includes('/user-management') ? styles.active : styles.inactive}>
											<img src={UserManagement} alt="amenities Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/user-management')} className={path.includes('/user-management') ? styles.active : styles.inactive}>
											<img src={UserManagement} alt="amenities Icon" />
											<span className={styles.menuText}>User Management</span>
										</div>
									</li>
							)}

							{canManageStaff && (
								!isExpanded ?
									<Tooltip text="Staff Management"><li >
										<div onClick={() => navigate('/staff-management')} className={path.includes('/staff-management') ? styles.active : styles.inactive}>
											<img src={StaffManagement} alt="staff add Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/staff-management')} className={path.includes('/staff-management') ? styles.active : styles.inactive}>
											<img src={StaffManagement} alt="staff add Icon" />
											<span className={styles.menuText}>Staff Management</span>
										</div>
									</li>
							)}

							{canReadVendor && (
								!isExpanded ?
									<Tooltip text="Vendor"><li >
										<div onClick={() => navigate('/vendor-appointments')} className={path.includes('/vendor-appointment') ? styles.active : styles.inactive}>
											<MaintenanceIcon color={path.includes('/vendor-appointments') ? '#fff' : '#000'} size={22} />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/vendor-appointments')} className={path.includes('/vendor-appointment') ? styles.active : styles.inactive}>
											<MaintenanceIcon color={path.includes('/vendor-appointments') ? '#fff' : '#000'} size={22} />
											<span className={styles.menuText}>Vendor</span>
										</div>
									</li>
							)}

							{canReadKeyPickUpDrop &&
								(!isExpanded ?
									<Tooltip text="Key PickUp & Drop "><li >
										<div onClick={() => navigate('/key-pickup-drop')} className={path.includes('/key-pickup-drop') ? styles.active : styles.inactive}>
											{/* <KeyIcon color={path.includes('/key-pickup-drop') ? '#fff' : '#000'} size={22} /> */}
											<KeyLockerIcon color={path.includes('/key-pickup-drop') ? '#fff' : '#000'} size={28} />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/key-pickup-drop')} className={path.includes('/key-pickup-drop') ? styles.active : styles.inactive}>
											{/* <KeyIcon color={path.includes('/key-pickup-drop') ? '#fff' : '#000'} size={22} /> */}
											<KeyLockerIcon color={path.includes('/key-pickup-drop') ? '#fff' : '#000'} size={28} />
											<span className={styles.menuText}>Key PickUp & Drop</span>
										</div>
									</li>
								)}
							{(email?.endsWith('@tourwithpineapple.com') || email?.toLowerCase().includes('tourwithpineapple') || email?.endsWith('@bytestechnolab.com') || email?.toLowerCase().includes('bytestechnolab')) && (
								!isExpanded ? (
									<Tooltip text="Concierge"><li >
										<div onClick={() => navigate('/all-scheduled-tours')} className={path.includes('/all-scheduled-tours') ? styles.active : styles.inactive}>
											<ConciergeIcon color={path.includes('/all-scheduled-tours') ? '#fff' : '#000'} size={28} />
										</div>
									</li></Tooltip>
								) : (
									<li>
										<div onClick={() => navigate('/all-scheduled-tours')} className={path.includes('/all-scheduled-tours') ? styles.active : styles.inactive}>
											<ConciergeIcon color={path.includes('/all-scheduled-tours') ? '#fff' : '#000'} size={28} />
											<span className={styles.menuText}>All Scheduled Tours</span>
										</div>
									</li>
								)
							)}

							{canSupportTicket && (!isExpanded ?
								<Tooltip text="Support Ticket"><li>
									<div onClick={() => navigate('/support-ticket')} className={path === '/support-ticket' ? styles.active : styles.inactive}>
										<img src={HeadsetIcon} alt="headset Icon" />
									</div>
								</li></Tooltip>
								:
								<li>
									<div onClick={() => navigate('/support-ticket')}
										className={path === '/support-ticket' ? styles.active : ''}>
										<img src={HeadsetIcon} alt="headset Icon" />
										<span className={styles.menuText}>Support Ticket</span>
									</div>
								</li>
							)}

							{canSetRolesAndPermissions && (
								!isExpanded ?
									<Tooltip text="Roles & Permissions"><li >
										<div onClick={() => navigate('/role-listing')} className={path.includes('/role-listing') || path.includes('/role-permission') ? styles.active : styles.inactive}>
											<img src={RolesAndPermission} alt="roles Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div onClick={() => navigate('/role-listing')} className={path.includes('/role-listing') || path.includes('/role-permission') ? styles.active : styles.inactive}>
											<img src={RolesAndPermission} alt="roles Icon" />
											<span className={styles.menuText}>Roles & Permissions</span>
										</div>
									</li>
							)}

							{(email === 'admindash@tourwithpineapple.com') && (
								!isExpanded ?
									<Tooltip text="Settings"><li>
										<div className={path === '/app-config' ? styles.active : styles.inactive}
											onClick={() => {
												navigate('/app-config');
											}}>
											<img src={iconSettings} alt="Cog Icon" />
										</div>
									</li></Tooltip>
									:
									<li>
										<div className={path === '/app-config' ? styles.active : styles.inactive}
											onClick={() => {
												navigate('/app-config');
											}}>
											<img src={iconSettings} alt="Cog Icon" />
											<span className={styles.menuText}>Settings</span>
										</div>
									</li>
							)}
						</React.Fragment>}
					</ul>
				</div>
			</div >

			{/* Toggle Button - Integrated at bottom */}
			<button
				className={styles.toggleButton}
				onClick={() => setIsExpanded(!isExpanded)}
				aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
			>
				<span className={styles.toggleIcon}>
					{isExpanded ? (
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					) : (
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					)}
				</span>
				{isExpanded && <span className={styles.toggleText}>Collapse</span>}
			</button>

			<button className={styles.iconLogout} onClick={handleLogout}>
				{/* <img src={iconLogout} alt="Icon Logout" /> */}
				<LogoutIcon color="#ef4444" />
				{isExpanded && <span className={styles.logoutText}>Logout</span>}
				{!isExpanded && <span className={styles.tooltip}>Logout</span>}
			</button>
		</div >
	);
};

export default sidebar;